import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "model-list"
};
const _hoisted_2 = ["onClick"];
export default /*@__PURE__*/_defineComponent({
  __name: 'TabBlock',
  props: {
    tabs: {},
    modelValue: {}
  },
  emits: ["update:modelValue", "change"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const handleClick = item => {
      if (props.modelValue === item.value) return;
      emits('update:modelValue', item.value);
      emits('change', item.value);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("ul", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, item => {
        return _openBlock(), _createElementBlock("li", {
          key: item.value,
          class: _normalizeClass({
            active: __props.modelValue === item.value
          }),
          onClick: $event => handleClick(item)
        }, _toDisplayString(item.label), 11, _hoisted_2);
      }), 128))]);
    };
  }
});